export default "__VITE_ASSET__5c9e9292__"